import React from "react";
import {connect} from "react-redux";
import {updatePage} from "../../actions/page";
import {DEFAULT_PER_PAGE} from "../../config";
import {displayErrors} from "../../libs/utils";
import {deleteCompanyAPIKey, loadCompanyAPIKeys} from "../../actions/account";
import {DateTimeFormat} from "../shared/DateTimeFormat";
import AccessItem from "../permissions/AccessItem";
import {Alert, Button, Col, message, Modal, Popconfirm, Row, Space, Table, Tooltip, Typography} from "antd";
import AccessGate from "../permissions/AccessGate";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import UndoOutlined from "@ant-design/icons/lib/icons/UndoOutlined";
import EditOutlined from "@ant-design/icons/lib/icons/EditOutlined";
import {hasPermission} from "../permissions/PermissionUtils";
import {DeleteOutlined} from "@ant-design/icons";
import CompanyUserPermissionsModal from "./CompanyUserPermissionsModal";
import Paragraph from "antd/es/typography/Paragraph";

class APIKeys extends React.Component {
    state = {
        pagination: { current: 1, pageSize: DEFAULT_PER_PAGE, total: 0, showSizeChanger: true },
        data: [],
        loadingData: true,
        showAPIKeyModal: false,
        activeAPIKey: null,
        activeAPIKeyData: null,
        apiKeyModalAction: 'CREATE',
        showNewAPIKeyModal: false,
        newAPIToken: ''
    };

    componentDidMount() {
        this.props.updatePage('API Keys');
        this.loadAPIKeys();
    }

    loadAPIKeys(page = null, per_page = null) {
        if(page === null) {
            page = this.state.pagination.current;
        }

        if(per_page === null) {
            per_page = this.state.pagination.pageSize;
        }

        this.setState({ loadingData: true });

        this.props.loadCompanyAPIKeys(this.props.companyGuid, page, per_page, (res) => {
            this.setState({ data: res.data.data, loadingData: false, pagination: { current: res.data.page, pageSize: res.data.per_page, total: res.data.total, showSizeChanger: true }});
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loadingData: false });
                displayErrors(err.response.data);
            }
        });
    }

    deleteAPIKey(guid) {
        this.props.deleteCompanyAPIKey(this.props.companyGuid, guid, () => {
            message.success('API key successfully deleted!');
            this.loadAPIKeys();

        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loadingData: false });
                displayErrors(err.response.data);
            }
        });
    }

    changePage(data) {
        this.loadAPIKeys(data.current, data.pageSize);
    }

    closeAPIKeyModal() {
        this.setState({ showNewAPIKeyModal: false, newAPIToken: '' });
    }

    render() {
        const columns = [
            {title: 'Name', dataIndex: 'name'},
            {title: 'Created', dataIndex: 'date_created', render: (item) => <DateTimeFormat value={item}/>},
            {
                title: 'Expires',
                dataIndex: 'date_expires',
                render: (item) => item === null ? 'Never' : <DateTimeFormat value={item}/>
            },
            { title: 'IP addresses', dataIndex: 'allowed_ip_addresses', render: (item) => item.join(', ')},
        ];

        if (hasPermission(this.props.company.permissions, ['can_create_api_keys'])) {
            columns.push({
                align: 'right', render: (item, record) => {
                    return <Space>
                        <Button size='small' icon={<EditOutlined/>} onClick={() => this.setState({ showAPIKeyModal: true, apiKeyModalAction: 'EDIT', activeAPIKey: item.user_id, activeAPIKeyData: item })}>Edit</Button>
                        <Popconfirm
                            onConfirm={() => this.deleteAPIKey(record.guid)}
                            placement='topRight'
                            title="Are you sure you want to delete it?"
                            okText="Delete"
                            okType='danger'
                            cancelText="Cancel">
                            <Button size='small' danger icon={<DeleteOutlined/>}/>
                        </Popconfirm>
                    </Space>;
                }
            });

            const { Text } = Typography;

            return (
                <AccessGate scopes={['can_view_api_keys']}>
                    <Row justify='space-between' style={{marginBottom: '10px'}}>
                        <Col>
                            <AccessItem scopes={['can_create_api_keys']}>
                                <Button type='primary' icon={<PlusOutlined/>}
                                        onClick={() => this.setState({ showAPIKeyModal: true})}>Create API Key</Button>
                            </AccessItem>
                        </Col>
                        <Col><Tooltip title='Reload' placement='left'>
                            <Button onClick={() => this.loadAPIKeys()} type='text' icon={<UndoOutlined/>}/></Tooltip>
                        </Col>
                    </Row>
                    <div style={{overflowX: 'auto'}}>
                        <Table
                            columns={columns}
                            rowKey={(item) => item.guid}
                            dataSource={this.state.data}
                            loading={this.state.loadingData}
                            pagination={this.state.pagination}
                            onChange={(e) => this.changePage(e)}
                        />
                    </div>

                    <CompanyUserPermissionsModal
                        open={this.state.showAPIKeyModal}
                        close={(reload) => {
                            this.setState({activeAPIKey: null, showAPIKeyModal: false});

                            if (reload) {
                                this.loadAPIKeys();
                            }
                        }}
                        companyGuid={this.props.companyGuid}
                        userType='API_KEY'
                        action={this.state.apiKeyModalAction}
                        apiKeyData={this.state.activeAPIKeyData}
                        createdAPIKey={(token) => this.setState({ showNewAPIKeyModal: true, newAPIToken: token })}
                        selectedUser={this.state.activeAPIKey} />

                    <Modal
                        title='Your API Key'
                        maskClosable={false}
                        footer={<Button type='primary' onClick={() => this.closeAPIKeyModal()}>Close</Button>}
                        onCancel={() => this.closeAPIKeyModal()}
                        open={this.state.showNewAPIKeyModal}>
                        <Alert type='warning' showIcon message={<span>Make sure to save this API key now, this is the only time it will be shown.</span>} />
                        <br />
                        <Paragraph copyable={{ text: this.state.newAPIToken }}><Text code>{this.state.newAPIToken}</Text></Paragraph>
                    </Modal>
                </AccessGate>
            );
        }
    }
}

const mapStateToProps = state => ({
    company: state.auth.user.user.company
});

export default connect(mapStateToProps, { updatePage, loadCompanyAPIKeys, deleteCompanyAPIKey })(APIKeys);